import gql from 'graphql-tag'

// Load Intercom uses custom `loadIntercom` schema extension
export const loadIntercom = gql`
	mutation($email: String!, $platform: String!) {
		loadIntercom(email: $email, platform: $platform) {
			hash
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/intercom.js